import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import WebPlayer from 'web/components/common/WebPlayer';

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const { jwplayer = {}, hasWebplayer, isPlayer } = rest;
      // const { handle, player, status, repeatList } = jwplayer;

      if (
        !hasWebplayer &&
        jwplayer &&
        jwplayer.player &&
        jwplayer.status &&
        jwplayer.status.playing
      ) {
        jwplayer.player.pause();
      }

      if (rest.public && rest.public.unauthorized) {
        // 로그인 사용자를 차단
        return (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location },
            }}
          />
        );
      }

      return (
        <>
          <Component
            {...props}
            hasWebplayer={hasWebplayer}
            jwplayer={jwplayer}
          />
          {!window.isMobile && hasWebplayer ? (
            <WebPlayer
              user={rest.auth.user}
              status={jwplayer.status}
              player={jwplayer.player}
              handle={jwplayer.handle}
              repeatList={jwplayer.repeatList}
              isPlayer={isPlayer}
              pushModal={rest.pushModal}
            />
          ) : null}
        </>
      );
    }}
  />
);

export default PublicRoute;
